import React, { Component } from 'react'
import { map } from 'lodash'
import { MetaData } from '../apis/meta.api'
import Row from '../components/Row/Row'
import InventoryCreateMetadataField from './InventoryCreateMetadataField'

interface InventoryCreateMetadataFieldsProps {
  metas: MetaData[]
  onChange: (metaId: number, value: string) => void
}

export default class InventoryCreateMetadataFields
  extends Component<InventoryCreateMetadataFieldsProps> {
  get fields () {
    return map(this.props.metas, meta => {
      return (
        <InventoryCreateMetadataField
          key={meta.value}
          meta={meta}
          onChange={this.props.onChange} />
      )
    })
  }

  render () {
    return (
      <Row column={3}>
        {this.fields}
      </Row>
    )
  }
}
